export default {
  BACK_TO (state, value) {
    state.backTo = value
  }
}
